export const useQueryString = () => {
    var _a;
    return ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.search) ? new URLSearchParams(window.location.search) : new URLSearchParams();
};
export const useQueryStringToken = (qs, key = 'token') => {
    const token = qs.get(key || 'token');
    if (token) {
        // React, URLSearchParams or useLocation() can replace the "+" character to a space. To prevent
        // the token from being invalidated
        return token.trim().replace(/ /g, '+');
    }
    return '';
};
//# sourceMappingURL=index.js.map